import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as GroomingSelfiesActions from "../../../store/actions/GroomingSelfies";
import * as UserActions from "./../../../store/actions/User";
import {
  isValidated as isValidatedForMandatoryFields,
  filterObj,
} from "../../../utils";
import styles from "../../../constants/assets/variables";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";

const GroomingSelfiesModal = ({
  modalState,
  handleClose,
  activeFilters,
  filterFields,
  getGroomingSelfiesList,
  resetGroomingSelfiesStore,
  setStatus,
}) => {
  const [initialState, setInitialState] = useState({
    driver_id: "",
    selfie_type: "",
    ref_trip_id: "",
    start_date: "",
    end_date: "",
  });
  const [currentDate, setCurrentDate] = useState();

  const filterTypes = ["ASSETS", "FACE", "FACE_TSHIRT", "BAG_QR", "BAG", "BAG_CLEANLINESS"];

  const isValidated = (body) => {
    let hasNoErrors = true;
    let validationState = isValidatedForMandatoryFields(body, [
      "driver_id",
      "selfie_type",
    ]);
    if (validationState !== "validated") {
      hasNoErrors = false;
      setStatus({
        type: "error",
        message: "Driver Id and Selfie Type are Mandatory",
      });
    }

    if (body["start_date"] && body["end_date"]) {
      let endDate = new Date(body["end_date"]);
      let startDate = new Date(body["start_date"]);
      if (startDate > endDate) {
        hasNoErrors = false;
        setStatus({
          type: "error",
          message: "Start date should come before end date",
        });
      }
    }
    return hasNoErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let body = filterObj(initialState, filterFields);
    if (!isValidated(body)) {
      return;
    }
    let filters = {};
    for (let key of filterFields) {
      if (body[key] !== "") {
        filters[key] = body[key] + "";
      }
    }

    getGroomingSelfiesList(filters).then((_) => {
      handleClose();
    });
  };

  const handleClearFilters = () => {
    resetGroomingSelfiesStore();
    handleClose();
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  useEffect(() => {
    // set max date
    setCurrentDate(new Date().toISOString().substring(0, 10));
    //set the initial state of form in modal
    if (Object.keys(activeFilters).length > 0) {
      let values = { ...initialState };
      Object.keys(values).forEach((key, _) => {
        if (activeFilters[key]) {
          values[key] = activeFilters[key];
        }
      });
      setInitialState(values);
    }
  }, [activeFilters]);

  return (
    <NoFooterModal
      header
      heading={"Driver Selfies Filter"}
      id="groomingSelfiesFilterModal"
      handleClose={handleClose}
      modalButtons={
        <BottomSectionModal>
          <FlexContainer>
            <Button
              data-testid="saveButton"
              onClick={handleClearFilters}
              className="sushi-btn"
            >
              Clear
            </Button>
            <Button
              data-testid="applyFiltersButton"
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Apply
            </Button>
          </FlexContainer>
        </BottomSectionModal>
      }
    >
      <div>
        <Input
          value={initialState.driver_id}
          onChange={(e) => handleChange("driver_id", e)}
          id="sushi-input"
          label="Driver FE ID"
          data-testId="DriverId"
          required={true}
          fullWidth={true}
          borderColor={styles.primaryColor}
          autoFocus={true}
        />
        <div id="selfieType">
          <PaginatedReactDropdown
            options={filterTypes}
            labelWidth="20%"
            handleChange={handleChange}
            keyToChange="selfie_type"
            placeholder="Selfie Type"
            showCross={true}
            showPagination={false}
            value={initialState.selfie_type}
            id="selfieTypesDropdown"
          />
        </div>
        <Input
          type="number"
          value={initialState.ref_trip_id}
          onChange={(e) => handleChange("ref_trip_id", e)}
          id="sushi-input"
          inputProps={{
            "data-testid": "refTripId",
          }}
          label="Delivery Trip Id"
          required={false}
          fullWidth={true}
          borderColor={styles.primaryColor}
        />
        <Input
          max={currentDate}
          id="sushi-input"
          borderColor={styles.primaryColor}
          label="Start Date"
          type="date"
          value={initialState.start_date ? initialState.start_date : "  "}
          onChange={(e) => handleChange("start_date", e)}
          fullWidth={true}
        />
        <Input
          max={currentDate}
          id="sushi-input"
          label="End Date"
          type="date"
          value={initialState.end_date ? initialState.end_date : "  "}
          onChange={(e) => handleChange("end_date", e)}
          fullWidth={true}
          borderColor={styles.primaryColor}
        />
      </div>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { GroomingSelfies } = state;
  return {
    activeFilters: GroomingSelfies.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetGroomingSelfiesStore: () =>
      dispatch(GroomingSelfiesActions.resetState({})),
    getGroomingSelfiesList: bindActionCreators(
      GroomingSelfiesActions.getGroomingSelfiesList,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroomingSelfiesModal);
